import { History } from 'lucide-react';

import { Datatable } from '@@/datatables';
import { useTableState } from '@@/datatables/useTableState';

import { useAutoPatches } from './useAutoPatches';
import { createStore } from './store';
import { columns } from './columns';

const tableKey = 'auto-patch-datatable';

const settingsStore = createStore(tableKey);

export function AutoPatchDatatable() {
  const tableState = useTableState(settingsStore, tableKey);

  const query = useAutoPatches();

  return (
    <Datatable
      title="Patch history"
      titleIcon={History}
      columns={columns}
      dataset={query.data?.autoUpdates ?? []}
      isLoading={query.isLoading}
      settingsManager={tableState}
      disableSelect
      includeSearch={false}
      data-cy="environment-update-schedules-datatable"
    />
  );
}
